import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import Calendar from '@components/icons/Calendar.svg';
import ErrorIcon from '@components/icons/FormError.svg';
import { TProps } from './types/TProps';

export const Icon = ({ onIconClick, error }: TProps) => {
  if (error) {
    if (!onIconClick) {
      return <ErrorIcon className="icon" />;
    }
    return (
      <IconButtonClean type="button" className="icon clickable" onClick={onIconClick}>
        <ErrorIcon />
      </IconButtonClean>
    );
  }
  if (!onIconClick) {
    return <Calendar className="icon" />;
  }
  return (
    <IconButtonClean type="button" className="icon clickable" onClick={onIconClick}>
      <Calendar />
    </IconButtonClean>
  );
};
